import { z } from 'zod';
import { SchemaFormDefinition } from '@mews-commander/form';
import { Option } from '@mews-commander/types';
import { lt } from '@mews/framework';

export const attachmentsTableFilterSchema = z
    .object({
        name: z.string().optional(),
        service: z.array(z.string()).optional(),
    })
    .partial();

export type AttachmentsTableFilterValues = z.infer<typeof attachmentsTableFilterSchema>;

export const attachmentsTableFiltersFormDefinition = ({
    serviceOptions,
}: {
    serviceOptions?: Option[];
}): SchemaFormDefinition<typeof attachmentsTableFilterSchema> => ({
    fields: {
        name: {
            label: lt('ContractsAttachmentLibraryCustomFileName'),
            field: { clearable: true, type: 'text' },
        },
        service: {
            label: lt('ContractsAttachmentLibraryApplicableServices'),
            field: {
                type: 'select',
                options: serviceOptions ?? [],
                showEmptyValue: false,
            },
        },
    },
});
